import './style/DesignResearch.scss';
import DesignResearch from "./js/DesignResearch";

export default DesignResearch;
